jQuery.fn.putCursorAtEnd = function () {

    return this.each(function () {

        // Cache references
        var $el = $(this),
            el = this;

        // Only focus if input isn't already
        if (!$el.is(":focus")) {
            $el.focus();
        }

        // If this function exists... (IE 9+)
        if (el.setSelectionRange) {

            // Double the length because Opera is inconsistent about whether a carriage return is one character or two.
            var len = $el.val().length * 2;

            // Timeout seems to be required for Blink
            setTimeout(function () {
                el.setSelectionRange(len, len);
            }, 1);

        } else {

            // As a fallback, replace the contents with itself
            // Doesn't work in Chrome, but Chrome supports setSelectionRange
            $el.val($el.val());

        }

        // Scroll to the bottom, in case we're in a tall textarea
        // (Necessary for Firefox and Chrome)
        this.scrollTop = 999999;

    });

};

jQuery.fn.copyToClipboard = function () {

    return this.each(function () {
        // is element selectable?
        if (this.select) {
            copySelect(this);
        } else {
            copyContent(this);
        }
    });
};

jQuery.fn.slideFlexDown = function (force) {

    return this.each(function () {

        // Cache references
        var $el = $(this);

        $el.slideDown({
            start: function () {
                if (force === true) {
                    // needed for Safari browser
                    $el.css('display', 'block');
                    setTimeout(function () { $el.css('display', 'flex'); }, 50)
                } else {
                    $el.css('display', 'flex');
                }
            }
        });
    });
};

jQuery.fn.showModal = function () {

    return this.each(function () {

        // Cache references
        var $el = $(this);
        var modalTimeout = 300;

        var jqModalElem = $el;
        var jqModalBox = jqModalElem.find(".modal__box");

        jqModalElem.fadeIn(modalTimeout);
        jqModalBox.fadeIn(300);

        // remove modal when clicking outside it
        $(document).bind('click', hideAnyModal);
    });
};

jQuery.fn.isInViewport = function () {
    var $el = this;

    let elementTop = $el.offset().top;
    let elementHeight = $el.outerHeight();
    let elementBottom = elementTop + elementHeight;

    let viewportTop = $(window).scrollTop();
    let winHeight = $(window).height();
    let viewportBottom = viewportTop + winHeight;

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

jQuery.fn.isFullInViewport = function () {
    var $el = this;

    let elementTop = $el.offset().top;
    let elementHeight = $el.outerHeight();
    let elementBottom = elementTop + elementHeight;

    let viewportTop = $(window).scrollTop();
    let winHeight = $(window).height();
    let viewportBottom = viewportTop + winHeight;

    return viewportBottom <= elementBottom && elementTop <= (viewportTop + 50);
};

jQuery.fn.scrollOnto = function (speed) {

    return this.each(function () {

        // Cache references
        var jqSelf = $(this);

        speed = isNaN(speed) ? 500 : speed, offset = -10;

        $('body,html').stop(false, false).animate({
            scrollTop: jqSelf.offset().top + offset
        }, speed, 'linear');
    });
};

jQuery.fn.borderFocus = function () {
    return this.each(function () {
        $(this).addClass('border-animation').focus();
    });
};

$.fn.exists = function () {
    return this.length > 0;
}

jQuery.fn.getZIndexOfNearestParent = function () {

    // Cache references
    var jqSelf = $(this);

    var recursiveZIndexSearch = function (element) {
        
        // Break on body.
        if (element[0] === $('body')[0]) {
            return 2;
        }

        // Get parent element
        var jqParent = element.parent();
        if (jqParent.length == 0) {
            return 0;
        }

        // Check if parent has z-index
        var zIndex = jqParent.css('z-index');
        if (zIndex.length > 0 && !(/\D/).test(zIndex)) {

            // Return found z-index.
            return zIndex;
        }

        // Z-index not found, try again on next parent.
        return recursiveZIndexSearch(jqParent);
    };

    return parseFloat(recursiveZIndexSearch(jqSelf));
};

jQuery.fn.visible = function () {
    return this.css('visibility', 'visible');
};

jQuery.fn.invisible = function () {
    return this.css('visibility', 'hidden');
};


if (window.ko) {

    // Here's a custom Knockout binding that makes elements shown/hidden via jQuery's fadeIn() /fadeOut() methods
    ko.bindingHandlers.fadeVisible = {
        init: function (element, valueAccessor) {
            // Initially set the element to be instantly visible/hidden depending on the value
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
        },
        update: function (element, valueAccessor) {
            // Whenever the value subsequently changes, slowly fade the element in or out
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
        }
    };

    var alreadySlided = false;
    ko.bindingHandlers.oneTimeSlideVisible = {
        init: function (element, valueAccessor) {
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value));
        },
        update: function (element, valueAccessor) {
            var value = valueAccessor();
            if (ko.unwrap(value)) {
                var isHidden = $(element).is(':hidden');
                if (isHidden && !alreadySlided) {
                    $(element).slideDown();
                    alreadySlided = true;
                } else {
                    $(element).show();
                }
            } else {
                $(element).hide();
            }
        }
    };
}

// Event that fires when an Element is changing its height
function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight, newHeight;
    (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight != newHeight)
            callback(newHeight)
        lastHeight = newHeight

        if (elm.onElementHeightChangeTimer)
            clearTimeout(elm.onElementHeightChangeTimer)

        elm.onElementHeightChangeTimer = setTimeout(run, 200)
    })();
}

// Attach an event handler function for one or more events to the selected elements if the event was not triggered for a given interval. 
// Refer to https://github.com/yckart/jquery.unevent.js
; (function ($) {
    var on = $.fn.on, timer;
    $.fn.on = function () {
        var args = Array.apply(null, arguments);
        var last = args[args.length - 1];

        if (isNaN(last) || (last === 1 && args.pop())) return on.apply(this, args);

        var delay = args.pop();
        var fn = args.pop();

        args.push(function () {
            var self = this, params = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(self, params);
            }, delay);
        });

        return on.apply(this, args);
    };
}(this.jQuery || this.Zepto));

// Detecting browsers by ducktyping
; (function ($) {
    $.getBrowser = function () {
        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]" 
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;

        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;

        // Chrome 1 - 79
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

        // Edge (based on chromium) detection
        var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

        // Blink engine detection
        var isBlink = (isChrome || isOpera) && !!window.CSS;

        if (isFirefox) return 'Firefox';
        if (isChrome) return 'Chrome';
        if (isSafari) return 'Safari';
        if (isOpera) return 'Opera';
        if (isIE) return 'IE';
        if (isEdgeChromium) return 'EdgeChromium';
        if (isBlink) return 'Blink';
    };
}(jQuery));

function copySelect(input) {
    input.select();
    input.setSelectionRange(0, 99999); /*For mobile devices*/

    try {
        document.execCommand('copy');
        input.blur();
    }
    catch (err) {
        console.log(err.message);
    }
}

function copyContent(element) {
    var range = document.createRange();
    range.selectNodeContents(element);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    try {
        document.execCommand('copy');
    } catch (err) {
        console.log(err.message);
    }

    selection.removeAllRanges();
}